import { ImgHTMLAttributes, useState } from 'react';

import { ImageBase64 } from '@/helpers/fileHelper';

type SupportedFormats = 'webp' | 'svg';
export type ImgFilename<P extends string = string, F extends SupportedFormats = SupportedFormats> = `${P}.${F}`;
export type ImgPath<
  Path extends string = string,
  Format extends SupportedFormats = SupportedFormats,
  I extends ImgFilename = ImgFilename<Path, Format>,
> = `/images/${I}`;
export type ExternalImgPath<
  Path extends string = string,
  Entity extends string = string,
  ExtDomainResource extends string = string,
> = `/storage/${Entity}/icons/${Path}` | `https://${ExtDomainResource}`;

export interface ImgProps extends ImgHTMLAttributes<HTMLImageElement> {
  src: ImgPath | ExternalImgPath | ImageBase64 | '#';
  alt: string;
  loading?: 'eager' | 'lazy';
  fallback?: ImgPath;
}

export const Image: React.FC<ImgProps> = (props) => {
  const [hasError, setHasError] = useState<boolean>(props.src === '#');

  const handleError = (): void => {
    if (!hasError && props.fallback) {
      setHasError(true);
    }
  };

  return (
    // eslint-disable-next-line custom/no-native-img
    <img
      {...props}
      src={hasError ? props.fallback : props.src}
      alt={props.alt}
      loading={props.loading ?? 'lazy'}
      onError={handleError}
    />
  );
};
